module.exports = __webpack_public_path__ + "img/GSQ_Logo.a1c25f6d.jpg";